import React, { useState } from "react";
import garmentRetouch1 from "../../../assets/FlowEdit/SixthFoldInner/garment_retouch1.webp";
import garmentRetouch2 from "../../../assets/FlowEdit/SixthFoldInner/garment_retouch2.webp";
import fabricChange1 from "../../../assets/FlowEdit/SixthFoldInner/fabric_change1.webp";
import fabricChange2 from "../../../assets/FlowEdit/SixthFoldInner/fabric_change2.webp";
import BeforeAfterSlider from "../../../common/BeforeAfter";
import "./style.scss";
import { Modal } from "antd";
import ContactUsComponent from "../../../common/ContactUs";

const SixthFoldInner = () => {
  const [showContact, setShowContact] = useState(false);
  const foldContent = [
    {
      id: 1,
      beforeImage: garmentRetouch1,
      afterImage: garmentRetouch2,
      title: "Garment Retouching",
      description:
        "Remove wrinkles, adjust fabric textures, and refine details in apparel images, ensuring each garment looks professionally presented and visually appealing.",
    },
    {
      id: 2,
      beforeImage: fabricChange1,
      afterImage: fabricChange2,
      title: "Fabric Change",
      description:
        "Change the fabric or texture in your apparel images to reflect different styles or colors, giving your product images versatility without new photography.",
    },
  ];

  const getContactUsModal = () => {
    return (
      <Modal
        // title="Basic Modal"
        open={showContact}
        footer={null}
        width="85%"
        height="90dvh"
        className="contact_us_modal_wrapper"
        onCancel={() => setShowContact(false)}
      >
        <ContactUsComponent
          closeModal={() => setShowContact(false)}
          isModal={true}
        />
      </Modal>
    );
  };

  return (
    <div className="sixth_fold_inner">
      <div className="slider_boxes">
        {foldContent?.map((content) => {
          return (
            <div className={`box ${content.id % 2 === 0 ? "reverse" : ""}`}>
              <div className="image_box">
                <BeforeAfterSlider
                  beforeImage={content.beforeImage}
                  afterImage={content.afterImage}
                />
              </div>
              <div className="content_box">
                <h2 className="title">{content.title}</h2>
                <p className="description">{content.description}</p>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setShowContact(true);
                  }}
                >
                  Get Started
                </button>
              </div>
            </div>
          );
        })}
        {showContact && getContactUsModal()}
      </div>
    </div>
  );
};

export default SixthFoldInner;
